import React, { useEffect, useState, useRef } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useModel } from "hooks/useModel";
import styles from "./ChatArea.module.scss";
import { Box } from "@mui/material";
import { useRouter } from "next/router";
import {
  getMessageInfoTags,
  getTopicInfoTags,
  getInfoTagIdLabel,
  getInfoTagSelectedList,
  isInfoTagLoading,
  normalizeInfoTags,
} from "components/ai-chat/utils/tags";

const ChatAreaInputTagsGroup = ({ showAccount }: { showAccount: boolean }) => {
  const { chatlist, selectedKey, currentAccountTags, setCurrentAccountTags } = useModel("aichat");
  const [tagMoveButton, setTagMoveButton] = useState(false);
  const tagListRef = useRef<HTMLDivElement>(null);
  const accountTagsRef = useRef<HTMLDivElement>(null);
  const router = useRouter();

  useEffect(() => {
    const currentChat = chatlist.find((item) => item.id === selectedKey);
    const hasTopicTags =
      !!currentChat &&
      (currentChat.mentions !== undefined || currentChat.accountTags !== undefined);
    const topicTags = getTopicInfoTags(currentChat);
    const latestMessage = currentChat?.content?.at(-1);

    setCurrentAccountTags(
      hasTopicTags ? topicTags : normalizeInfoTags(getMessageInfoTags(latestMessage))
    );
  }, [chatlist, selectedKey, setCurrentAccountTags]);

  useEffect(() => {
    if (tagListRef.current && accountTagsRef.current) {
      const tagListWidth = tagListRef.current.offsetWidth;
      const accountTagsWidth = accountTagsRef.current.offsetWidth;
      setTagMoveButton(tagListWidth > accountTagsWidth);
    }
  }, [currentAccountTags]);

  const onTagScroll = (left: number) => {
    if (accountTagsRef.current) {
      accountTagsRef.current.scrollBy({
        left,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <Box
        className={`${styles.accountTags} ${showAccount ? styles.show : styles.hide}`}
        ref={accountTagsRef}
      >
        {tagMoveButton && (
          <div className={styles.tagMoveButton}>
            <div onClick={() => onTagScroll(-420)}>
              <img
                style={{ transform: "rotate(180deg)", paddingTop: "4px" }}
                src="/aichat/movebutton.svg"
                alt=""
              />
            </div>
            <div onClick={() => onTagScroll(420)}>
              <img
                src="/aichat/movebutton.svg"
                alt=""
              />
            </div>
          </div>
        )}
        <div
          style={{
            width: `${currentAccountTags.length * 208}px`,
          }}
          ref={tagListRef}
        >
          {currentAccountTags.map((tag, index) => (
            <div
              key={`${tag.type}-${getInfoTagIdLabel(tag) || index}`}
              className={styles.tagItem}
            >
              <div className={styles.tagItemTitle}>
                {router.query?.accountId === tag.id && !!router.query?.accountId && (
                  <span className={styles.tagItemCurrent}>[Current]</span>
                )}
                <span className={styles.tagItemName}>{tag.name}</span>
                {isInfoTagLoading(tag) && (
                  <CircularProgress
                    size={16}
                    style={{ marginLeft: 6 }}
                  />
                )}
              </div>
              <div className={styles.tagItemDescription}>
                {getInfoTagSelectedList(tag).join(", ") || getInfoTagIdLabel(tag)}
              </div>
            </div>
          ))}
        </div>
      </Box>
    </>
  );
};

export default ChatAreaInputTagsGroup;
